import SvgFrameAnimatorSetting from "../classes/svgFrameAnimatorSetting";

class SvgFramesController {
    public svgFrameAnimatorSettings: SvgFrameAnimatorSetting[] = [];

    public async LoadAnimationFrames(animationName: string, framesCount: number, fps: number, repeat?: boolean) {
        const frames = await this.LoadFrames(animationName, framesCount);
        this.svgFrameAnimatorSettings.push(new SvgFrameAnimatorSetting(
            animationName, framesCount, fps, frames, repeat
        ));
    }
    
    private async LoadFrames(animationName: string, framesCount: number) {
        const frames: any[] = [];
        //initialization
        for (let i = 0; i <= framesCount; i++) {
            frames.push('');
        }
        //load
        for (let i = 0; i <= framesCount; i++) {
            const frameLabel = i < 10 ? ('0' + i.toString()) : i.toString();
            frames[i] = await import(`../assets/animations/${animationName + '/frame' + frameLabel + '.svg'}`);
        }
        return frames;
    }
}
export default SvgFramesController;